import ReceiptScannerUiPage from '@the-coca-cola-company/receipt-scanner-admin-lib';
import { useEffect, useState, useMemo } from 'react';
import { determineRSEndpoint } from '../../hooks/generateRSToken'
import { Auth } from "aws-amplify";

const ReceiptScannerHandler = () => {
    const [rsToken, setRsToken] = useState<string | null>(null);

    useEffect(() => {
        const generateToken = async () => {
            try {
            const session = await Auth.currentSession();
            const idToken = session.getIdToken().getJwtToken();

            if (!idToken) return;
    
            setRsToken(idToken);
            } catch (err) {
                console.error('Error generating RS token:', err);
            }
        };
    
        generateToken();
    }, []);

    const config = useMemo(() => ({
        accessToken: rsToken,
        adminApiUrl: determineRSEndpoint(),
    }), [rsToken]);

    return rsToken && (
        <ReceiptScannerUiPage
            config={config}
        />
    );
};

export { ReceiptScannerHandler };